/**
 * Long enough for the browser to have taken the URL before it is dropped. Revoking in the same tick
 * as the click is usually fine, but has a history of cancelling the download outright in Safari, and
 * holding the blob a fraction of a second longer costs nothing. Matches the delay
 * useGetAndOpenRouteItem.ts uses for the same reason.
 */
const REVOKE_DELAY_MS = 200;

/**
 * Hands a generated file to the browser as a download.
 *
 * The object URL is revoked once the download has started: without it every export leaks the whole
 * blob for the lifetime of the tab, which for a thirty-six month workbook is not trivial.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(objectUrl), REVOKE_DELAY_MS);
}
